import { ListItemText } from '@mui/material';

import { GDMListItemTextComponent } from './GDMListItemText.type';

/* TODO: Implement component using GDM default design */
const GDMListItemText: GDMListItemTextComponent = props => <ListItemText {...props} />;

export default GDMListItemText;
